const initialSendData = {
  id: "0",
  mode: "add", // add ot edit
  date: "",
  factorType: "", //"b2b"  "organize" // خانگی / کسب . کار / سازمانی
  paymentType: "debt", //  نقد و بانک  - حساب دفتری cacheAndBank || debt
  sellType: "inPlace", // حضوری// حضوری بستر فروش inPlace || telegram || instagram || whatsapp
  serviceTitle: "", // عنوان خدمت
  servicePrice: 0, // عددی هست
  tax: 0,
  totalDiscount: 0,
  customerId: "", // درصورتی که گفته بود حساب دفتری این مورد پر میشه
  customerName: "انتخاب مشتری",
  customerType: "",

  prerequisiteMemberId:JSON.stringify({}),
  currentSelectedOrganizeName: "کد عضویت سازمان",
  organizeId: "",
  memberId:"",

  currentSelectedBankAccountName: "انتخاب بانک",
  currentBankAccountInputValue: "",
  // province: "",
  city: "",
  priceData: [// {uniqId: 1002121, id: "0", type: 'fund', price: 200, name: "صندوق"},
    // {uniqId: 12121, id: "0", type: 'bank', price: 500, name: "بانک میرعرب"},
  ],
  tableData: [], // آرایه ای از آبجکت ها که دیتای جدول بولاتور توی اون قرار گرفته
  currentCustomerId: "0",
  fundAccess: true,
  description: "",
  orderId: "",
  storePrintFlag: false, // showStorePrintCheckBox  so i must fill this key

  sendType: "courier", // courier , inPlace // نوع ارسال
  // اگه نوع ارسال پیک بود آرلوکاپ پیک رو باز میکنم
  courierName: "انتخاب پیک",
  courierId: "",

  sendStatus: "delivered", // "inProcess" , "courier" // وضعیت ارسال
  sendDatePeriodName: "انتخاب بازه زمانی",
  sendDatePeriodId: "",

  distributorContractor: false,
  distributorContractorName: "انتخاب پیمانکار توزیع",
  distributorContractorId: "",


  prerequisiteAddressId:JSON.stringify({}),
  addressDetail: "انتخاب آدرس",
  addressId: "",


}

const initialData = {
  fund: {id: "25", name: "صندوق شهپوری"},
  bankRLookUpId: 26,
  customerRLookUpId: 25,
  currentCustomerName: "انتخاب مشتری",
  sellType: true,
  provinceAndCity: true,
  province: "گلستان",
  city: "گرگان",
  description: "",
  currentSelectedCustomerId: '',
  customerName: 'انتخاب مشتری',
  currentSelectedBankAccountName: "انتخاب بانک",
  showStorePrintCheckBox: false,
  tax: 0,
}
const componentData = {
  // sum: 0,
  selectOptionColorSizeArray: [], selectedColorSizeValue: "",

  currentFundInputValue: "", // currentFundId   I will use initialData fund: {id: "25", name: "صندوق شهپوری"},

  listType: 'barcode', // barcode
  //internetId
  // name
  productsArrayList: [],  // list of names or internetIds or names
  searchData: "", focusSearchData: true,

  currentStoreName: "", currentStoreId: "",
  showOrganize: true,

}
const sellFactorData = {
  initialSendData, initialData, componentData,
}

export default sellFactorData